import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import PublicPage from "@/pages/PublicPage";
import LoginPage from "@/pages/admin/LoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import Products from "@/pages/admin/Products";
import Categories from "@/pages/admin/Categories";
import Analytics from "@/pages/admin/Analytics";
import Settings from "@/pages/admin/Settings";

function FullScreenLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FBFBFB]" data-testid="app-loading">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-black/10 border-t-black" />
    </div>
  );
}

function RequireAuth({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) return <FullScreenLoader />;
  if (!user) return <Navigate to="/admin/login" replace state={{ from: location }} />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-center" toastOptions={{ style: { borderRadius: "9999px" } }} />
        <Routes>
          <Route path="/" element={<PublicPage />} />
          <Route path="/category/:slug" element={<PublicPage />} />
          <Route path="/admin/login" element={<LoginPage />} />
          <Route
            path="/admin"
            element={
              <RequireAuth>
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route index element={<Overview />} />
            <Route path="products" element={<Products />} />
            <Route path="categories" element={<Categories />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<PublicPage />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
